import React from 'react'

export interface SmallArrowUpProps {
  size?: number
  color?: string
}

export const SmallArrowUp: React.FC<SmallArrowUpProps> = ({
  size = 16,
  color = '#00DB4B',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.437 5.857v6.038a.771.771 0 01-1.542 0V5.857l-.84.908c-.496.535-1.389.185-1.389-.544a.8.8 0 01.213-.544L6.932 3.46a1 1 0 011.468 0l2.053 2.217a.8.8 0 01.213.544c0 .729-.893 1.079-1.388.544l-.84-.908z"
        fill={color}
      />
    </svg>
  )
}
